import {getShopDetails} from 'ultra/helpers/shop';
import {isArray} from "lodash";
// import Skeleton from '@mui/material/Skeleton';

import PreloaderTopPagePicture from '../../../../../../../../Components/Preloaders/PreloaderTopPagePicture';
import PreloaderText from '../../../../../../../../Components/Preloaders/PreloaderText';

import {useNavigationStore} from '../../../../../../../../Stores/navigation';
import {useConfigStore} from '../../../../../../../../Stores/config';

import ShopProductPrice from '../../../../../../Widgets/ShopProductPrice'
import ContentImage from '../../../../../../Widgets/ContentImage'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import ShopingCart from '../../../../../../Widgets/ShopingCart'
import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import Gallery from '../../../../../../Widgets/Gallery';
import FilterChip from '../../../../../../Widgets/FilterChip'

import './index.scss'

export default function Template(props) {
    const {content, permits, config, form, breadcrumbs} = props

    const {shop} = getShopDetails(content, breadcrumbs)

    const {contentLoading} = useNavigationStore()
    const {configs} = useConfigStore();

    if (contentLoading) return <>
        <PreloaderTopPagePicture />
        <PreloaderText />
    </>

    return <div className="Service">
        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {/* {contentLoading && <div>
            <Skeleton variant="rectangular" width="100%" height={100} style={{marginBottom: '2rem'}} />
        </div>} */}

        {/* {!contentLoading &&  */}
        <div className="details">
            <div className="labelWrap price">
                <span className="label">Ціна:</span>
                <span className="labelValue">
                    <ShopProductPrice product={content} currency={shop?.partner_config?.currency} />
                </span>
            </div>

            <ShopingCart
                fullWidth
                item={content}
                shop={shop}
            />
        </div>
        {/* } */}

        <CKEditorContent content={content.description} />

        {isArray(content.category) && content.category.length > 1
            && <div className='categories'>
                {content.category.map(i => <FilterChip value={i} config={configs.content.nodes[content._type].fields.category || form.fields.category} />)}
            </div>
        }

        {content.banner && <ContentImage src="banner" image={content.banner} />}
        {content.gallery && <Gallery content={content.gallery} />}
    </div>
}
